import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LandingSectionRevealDirective } from "../../shared/landing-section-reveal.directive";
import { LANDING_1_STEPS } from "../../landing-1.section-data";

@Component({
  selector: "app-landing-1-how-it-works",
  standalone: true,
  imports: [TranslateModule, LandingSectionRevealDirective],
  templateUrl: "./landing-1-how-it-works.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1HowItWorksComponent {
  readonly steps = LANDING_1_STEPS;
}
